export const INSTANT_BOOK_INTEGER_ID = '89';
export const INSTANT_BOOK_FILTER_ID = `filter:${INSTANT_BOOK_INTEGER_ID}`;
export const LEGACY_INSTANT_BOOK_ID = 'booking_title:instant_booking';
export const INSTANT_BOOK_FILTER_LABEL = 'instant_booking';
export const FREE_CANCEL_60_DAYS_ID = 'filter:113';
export const FREE_CANCEL_30_DAYS_ID = 'filter:112';
export const FREE_CANCEL_14_DAYS_ID = 'filter:111';
export const BOOKING_OPTIONS_GROUP_ID = '9';
export const FREE_CANCELLATION_GROUP_ID = '23';
// non US brands localize "booking options" but not "instant book", e.g. for Fewo it's "Buchungsoptionen:Instant+book"
// so we can just check to see if the link value contains "instant book"
export const INSTANT_BOOK_SLOT_VALUE = 'instant book';
export const MAX_ELEMENTS_VISIBLE_COLLAPSED = 5;
export const PETS_INCLUDED_FILTER_ID = 'filter:27';
export const PRICE_FILTER_GROUP_ID = '26';
export const ROOMSANDSPACES_FILTER_GROUP_ID = '24';
